export const MyProfile = {
  navBtnStyles: {
    ButtonDefault: {
      borderRadius: "0px",
    },
    ButtonReverted: {
      borderRadius: "0px",
    },
  },
};
